import React from "react";

import { updatePassword } from "../../model/profile";

import { commonErr } from "../common/errors";
import { CustomInputLabelOutside } from "../components/input";
import { MessageBox } from "../common/messagebox";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";
import AccountSideBar from "../account/components/accountsidebar";

import { IcPassword, IcEye } from "../common/svg";

export default class ResetPw extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			ip_pw: "",
			ip_reset_pw: "",
			ip_reset_pw_confirm: "",
			ipTypePw: "password",
			ipTypeReset: "password",
			ipTypeResetPw: "password",
			showMessageBox: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	retry = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
			ip_pw: "",
			ip_reset_pw: "",
			ip_reset_pw_confirm: "",
		});
	};

	onResetPwBtnClick = () => {
		const { ip_pw, ip_reset_pw, ip_reset_pw_confirm } = this.state;

		if (ip_pw !== "" && ip_reset_pw !== "") {
			if (ip_reset_pw === ip_reset_pw_confirm) {
				updatePassword(ip_pw, ip_reset_pw).then((resp) => {
					if (resp?.data?.error === commonErr.SUCCESS) {
						this.setState({
							err: resp.data.error,
							errMsg: "Mật khẩu đã được làm mới thành công",
							showMessageBox: true,
						});
					} else {
						this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage,
							showMessageBox: true,
						});
					}
				});
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Mật khẩu mới không khớp.",
					showMessageBox: true,
				});
			}
		}
	};

	toggleInput = (name, str) => {
		this.setState({
			[`${name}`]: str,
		});
	};

	renderPw = (name, type) => {
		const ipType = type === "password" ? "text" : "password";

		return (
			<div className="wrap-svg" onClick={() => this.toggleInput(name, ipType)}>
				{type === "password" ? <IcPassword /> : <IcEye />}
			</div>
		);
	};

	showMessageBox = () => {
		this.setState({
			showMessageBox: true,
		});
	};

	hideMessageBox = () => {
		this.setState({
			showMessageBox: false,
		});
	};

	render() {
		const {
			err,
			errMsg,
			showMessageBox,
			ipTypePw,
			ipTypeReset,
			ipTypeResetPw,
			ip_pw,
			ip_reset_pw,
			ip_reset_pw_confirm,
		} = this.state;

		const icPw = this.renderPw("ipTypePw", ipTypePw);
		const icReset = this.renderPw("ipTypeReset", ipTypeReset);
		const icResetPw = this.renderPw("ipTypeResetPw", ipTypeResetPw);

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSideBar />
								<div className="content-account">
									<div className="content-title">
										<h4>Đổi mật khẩu</h4>
										<p>Vui lòng nhập mật khẩu hiện tại của bạn để thay đổi mật khẩu</p>
									</div>
									<div className="content-item change-pw">
										<div className="title">
											<h5>Nhập mật khẩu</h5>
										</div>
										<div className="content">
											<CustomInputLabelOutside
												type={ipTypePw}
												name={"ip_pw"}
												label="Mật khẩu hiện tại"
												onChange={this.handleInputChange}
												icRight={icPw}
											/>

											<CustomInputLabelOutside
												type={ipTypeReset}
												name={"ip_reset_pw"}
												label="Mật khẩu mới"
												onChange={this.handleInputChange}
												icRight={icReset}
											/>

											<CustomInputLabelOutside
												type={ipTypeResetPw}
												name={"ip_reset_pw_confirm"}
												label="Xác nhận mật khẩu mới"
												onChange={this.handleInputChange}
												icRight={icResetPw}
											/>

											<div className="apply-button">
												<a
													className="btn btn--m btn-primary"
													disabled={!ip_pw || !ip_reset_pw || !ip_reset_pw_confirm}
													onClick={this.onResetPwBtnClick}>
													Xác nhận
												</a>
											</div>
										</div>
										<MessageBox error={err} show={showMessageBox} hideModal={this.hideMessageBox} message={errMsg} />

										{/* 										
										<div className="line-form">
											<div className="wrap-input has-ico">
												<i className="ic ic-lock-fill"></i>
												<input type="password" placeholder="Mật khẩu mới" name="ip_reset_pw" onChange={this.handleInputChange} />
											</div>
										</div>
										<div className="line-form">
											<div className="wrap-input has-ico">
												<i className="ic ic-lock-fill"></i>
												<input type="password" placeholder="Lặp lại mật khẩu" name="ip_reset_pw_confirm" onChange={this.handleInputChange} />
											</div>
										</div>
								
										<button className="btn btn-primary btn--m" type="button" name="resetPw" onClick={this.onResetPwBtnClick}>Cập nhật mật khẩu</button> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<Footer />
			</div>
		);
	}
}
